import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/categoryValues')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/categoryValue' })
  },
})
